import axios, { type AxiosRequestConfig } from 'axios';
import { config, createHeaders } from '.';
import { LoadStoreByCompanyData } from '../models/Stores';
import { LoggedUser } from '../db/db';

export const loadStoresByCompanyId = async (
	user: LoggedUser,
	accessToken: string
) => {
	const localConfig: AxiosRequestConfig = {
		...config,
		url: `user/${user.id}/privilege/${user.userTypeId}/company/${user.companyId}/stores`,
		method: 'get',
		headers: createHeaders({ accessToken })
	};
	return axios.request<LoadStoreByCompanyData>(localConfig);
};
